import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** Line icons the Projukti icon tiles draw (storefront `HomeCategoryIcon.vue`); empty = guessed from the category name. */
export const CATEGORY_ICON_OPTIONS = [
  ['laptop', 'Laptop'], ['pc-case', 'Desktop PC'], ['monitor', 'Monitor'], ['cpu', 'Processor'], ['circuit-board', 'Motherboard'],
  ['memory-stick', 'RAM'], ['hard-drive', 'Storage'], ['gpu', 'Graphics card'], ['fan', 'Cooling'], ['router', 'Router'],
  ['wifi', 'Wi-Fi'], ['server', 'Server'], ['printer', 'Printer'], ['keyboard', 'Keyboard'], ['mouse', 'Mouse'],
  ['headphones', 'Headphones'], ['speaker', 'Speaker'], ['gamepad', 'Gaming'], ['camera', 'Camera'], ['webcam', 'Webcam / CCTV'],
  ['tv', 'TV'], ['smartphone', 'Phone'], ['tablet', 'Tablet'], ['watch', 'Smart watch'], ['battery-charging', 'UPS / power'],
  ['plug', 'Cables & adapters'], ['disc', 'Software'], ['package', 'Other'],
].map(([value, label]) => ({ value: value!, label: label! }))

/** Category tiles: chosen categories or links, or the store's categories when none are listed. */
export const schema: ComponentSchema = {
  type: 'category-bento',
  label: 'Category tiles',
  description: 'Category tiles with the product shot beside the name (2 / 4 per row), picture tiles (3 / 6 per row) or icon tiles (4 / 8 per row).',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Picture beside the name (2 / 4 per row)' },
    { id: 'v2', label: 'Picture above the name (3 / 6 per row)' },
    { id: 'v3', label: 'Icon tiles (4 / 8 per row)' },
  ],
  commonFields: [
    ...headingFields({ title: 'Shop by category', subtitle: 'Parts, devices and accessories, sorted for you.' }),
    {
      key: 'tiles',
      label: 'Tiles',
      type: 'array',
      help: 'Empty = the store’s categories. Leave the title empty for a grid without a heading.',
      itemSchema: [
        { key: 'categoryId', label: 'Category', type: 'category-select', help: 'Sets the link, name and picture unless filled below.' },
        { key: 'title', label: 'Name', type: 'localized-string' },
        { key: 'tagline', label: 'Tagline', type: 'localized-string', help: 'Shown when the category has no product count.' },
        { key: 'icon', label: 'Icon', type: 'icon', options: CATEGORY_ICON_OPTIONS, help: 'Shown when the tile has no picture of its own. Empty = guessed from the name.' },
        { key: 'image', label: 'Picture', type: 'image', help: 'Replaces the icon.' },
        { key: 'link', label: 'Link', type: 'string', placeholder: '/category/…' },
      ],
      default: [],
    },
    { key: 'limit', label: 'Categories shown (automatic tiles)', type: 'number', default: 24 },
    ...SECTION_STYLE_FIELDS,
  ],
}
